import React from "react";
import { TextField, RaisedButton, IconButton } from "material-ui";
import * as util from "../../util";
import assign from "lodash/assign";
import InlineLinkIconButton from "./inline-link-icon-button.jsx";

import PassActions from "../../actions/PassActions";

class PassNameEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      isSaving: false,
      isUpdatingActiveState: false,
      _lastUpdatedAt: null,
      updatedName: ""
    };

    this._save = this._save.bind(this);
    this._startEditing = this._startEditing.bind(this);
    this._toggleActive = this._toggleActive.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object
  };

  componentWillReceiveProps(newProps) {
    if (newProps.pass.updated_at !== this.state._lastUpdatedAt) {
      this.setState({
        isSaving: false,
        isEditing: false
      });
    }

    if (
      this.state.isUpdatingActiveState &&
      newProps.pass.is_active !== this.props.pass.is_active
    ) {
      this.setState({ isUpdatingActiveState: false });
    }
  }

  _save() {
    this.setState(
      {
        isSaving: true,
        _lastUpdatedAt: this.props.pass.updated_at
      },
      () => {
        PassActions.edit(this.props.pass.id, {
          name: this.state.updatedName
        });
      }
    );
  }

  _toggleActive(e) {
    e.preventDefault();
    this.setState(
      {
        isUpdatingActiveState: true,
        _lastUpdatedAt: this.props.pass.updated_at
      },
      () => {
        PassActions.edit(this.props.pass.id, {
          is_active: !this.props.pass.is_active
        });
      }
    );
  }

  _startEditing(e) {
    e.preventDefault();
    this.setState({
      isEditing: true,
      updatedName: this.props.pass.name
    });
  }

  getStyles() {
    return {
      editor: {
        marginTop: -13,
        marginBottom: -12,
        minWidth: 264
      },
      editButton: {
        marginLeft: 12,
        height: 28
      },
      editButtonLabel: {
        lineHeight: "28px"
      },
      textField: {
        lineHeight: "16px",
        height: 40,
        width: "60%",
        maxWidth: 250
      }
    };
  }

  render() {
    let { pass, isMembership } = this.props,
      styles = this.getStyles();

    return this.state.isEditing ? (
      <div style={styles.editor}>
        <TextField
          disabled={this.state.isSaving}
          style={styles.textField}
          onKeyDown={e => e.keyCode === 13 && this._save()}
          placeholder="Name"
          value={this.state.updatedName}
          onChange={e =>
            this.setState(
              assign({}, this.state, { updatedName: e.target.value })
            )
          }
        />
        &nbsp;
        <RaisedButton
          label={this.state.isSaving ? "Saving..." : "Save"}
          primary={true}
          disabled={this.state.isSaving}
          style={styles.editButton}
          labelStyle={styles.editButtonLabel}
          onTouchTap={this._save}
        />
      </div>
    ) : (
      <div style={{ whiteSpace: "nowrap" }}>
        {pass.is_active === false ? (
          <span style={{ whiteSpace: "normal" }}>
            <span style={{ textDecoration: "line-through" }}>{pass.name}</span>{" "}
            <span
              style={{
                fontStyle: "italic",
                backgroundColor: "red",
                borderRadius: 5,
                padding: "2px 4px",
                color: "white",
                fontSize: 10,
                verticalAlign: 1
              }}
            >
              Deactivated
            </span>
          </span>
        ) : (
          pass.name
        )}
        {this.props.showEditButton ? (
          <span> </span>
        ) : (
          <InlineLinkIconButton
            onTouchTap={() => {
              this.context.router.push({
                pathname: `/event_buckets/${
                  pass.event_bucket.id || pass.event_bucket
                }/people/${pass.person.id}`,
                query: { highlight_pass: pass.id },
                state: { ignoreScrollBehavior: true }
              });
            }}
            tooltip={isMembership ? "View membership" : "View pass"}
          />
        )}
        {this.props.showEditButton &&
          (this.state.isUpdatingActiveState ? (
            "(updating...)"
          ) : (
            <span>
              (
              <a
                style={this.props.linkStyle}
                href="#"
                onClick={this._startEditing}
              >
                edit
              </a>{" "}
              &middot;{" "}
              <a
                style={this.props.linkStyle}
                href="#"
                onClick={this._toggleActive}
              >
                {pass.is_active === false ? "activate" : "deactivate"}
              </a>
              )
            </span>
          ))}
      </div>
    );
  }
}

export default PassNameEditor;



// WEBPACK FOOTER //
// ./src/app/components/partials/pass-name-editor.jsx